import { Route, Switch} from 'react-router-dom'
import React from "react";
import mainRoutes from "./mainRoutes"
import {connect} from "react-redux";


const WrapRoute = (props) => {
    const { path, component, ...otherProps } = props;
    return <Route path={path} render={() =>  React.createElement(component, otherProps)}/>
}

const  MainRouting = ( props ) => {
    const { auth, isAuthenticated, grupo, grupoRotas, setTitulo, setLimite, tcContador } = props;

    console.log("MainRouting params =>", isAuthenticated, grupo, grupoRotas );
    const xgrupo = grupo?  grupo : "";
    const xgrupoRotas = grupoRotas? grupoRotas : mainRoutes;


     console.log("APROUTING MAINROUTING", grupo);

    //console.log("AUTH", auth);
    let ixm = 0;



    // console.log("routeIndex allprops", allprops);
    return (
        <React.Fragment>

                <Switch>
        {
            xgrupoRotas.map( (r,ix) => {
                if (!isAuthenticated && r.secgroup > 10) { return null }
                if (r.grupo &&  r.grupo !==  xgrupo ) { return null;}
                if ( auth.auth && auth.auth.frontEndPermissions && r.secgroup > 100 && !auth.auth.frontEndPermissions.includes(r.secgroup) )  { return null }

                if (r.collapse? r.collapse : false) {
                        return r.pages.map((ri,ix2) => {
                            if (!isAuthenticated && ri.secgroup > 10) { return null }
                            if ( auth.auth && auth.auth.frontEndPermissions && ri.secgroup > 100 && !auth.auth.frontEndPermissions.includes(ri.secgroup) )  { return null }
                            ixm = ixm +1;
                      //      console.log("ADD route collapsed", ri.path);
                            return (<Route key={ixm} path={ri.path} tcContador={tcContador}  component={ri.component}  setLimite={setLimite} />);
                        })
                }

                if ( r.component && r.component !== null && r.component !== "") {
                    ixm = ixm + 1;
                   // console.log("ADD route", r.path);
                   // return (<Route key={ixm}  {...r.routeParam} path={r.path} component={r.component}/>)

                    return (<WrapRoute key={ixm}  {...r.routeParam} path={r.path} component={r.component} tcContador={tcContador}  setTitulo={setTitulo} setLimite={setLimite} />)
                }
                return (null)
            })
        }
                </Switch>
        </React.Fragment>
    )
}
const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.id !== null && (state.auth.expiresIn * 1000 > new Date().getTime()) ,
        auth: state.auth
    }
}

export default connect(mapStateToProps)(MainRouting)

